module.exports = {
      id: "mail-usage",
      viewBox: "0 0 24 24",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#mail",
      toString: function () {
        return this.url;
      }
    }